'use strict';

var _regeneratorRuntime = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

var CID = require('cids');

var toCamelWithMetadata = require('../lib/object-to-camel-with-metadata');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(function (api) {
  return (
    /*#__PURE__*/
    function () {
      var _ls = _wrapAsyncGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(path) {
        var options,
            res,
            _iteratorNormalCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            _value,
            result,
            _iteratorNormalCompletion2,
            _didIteratorError2,
            _iteratorError2,
            _iterator2,
            _step2,
            entry,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

                if (!(!path || typeof path !== 'string')) {
                  _context.next = 3;
                  break;
                }

                throw new Error('ipfs.files.ls requires a path');

              case 3:
                _context.next = 5;
                return _awaitAsyncGenerator(api.post('files/ls', {
                  timeout: options.timeout,
                  signal: options.signal,
                  searchParams: toUrlSearchParams(_objectSpread({
                    arg: CID.isCID(path) ? "/ipfs/".concat(path) : path,
                    // default long to true, diverges from go-ipfs where its false by default
                    long: true
                  }, options, {
                    stream: true
                  })),
                  headers: options.headers
                }));

              case 5:
                res = _context.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 8;
                _iterator = _asyncIterator(res.ndjson());

              case 10:
                _context.next = 12;
                return _awaitAsyncGenerator(_iterator.next());

              case 12:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 16;
                return _awaitAsyncGenerator(_step.value);

              case 16:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 53;
                  break;
                }

                result = _value;

                if (!('Entries' in result)) {
                  _context.next = 48;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 23;
                _iterator2 = (result.Entries || [])[Symbol.iterator]();

              case 25:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 32;
                  break;
                }

                entry = _step2.value;
                _context.next = 29;
                return toCoreInterface(toCamelWithMetadata(entry));

              case 29:
                _iteratorNormalCompletion2 = true;
                _context.next = 25;
                break;

              case 32:
                _context.next = 38;
                break;

              case 34:
                _context.prev = 34;
                _context.t0 = _context["catch"](23);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 38:
                _context.prev = 38;
                _context.prev = 39;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 41:
                _context.prev = 41;

                if (!_didIteratorError2) {
                  _context.next = 44;
                  break;
                }

                throw _iteratorError2;

              case 44:
                return _context.finish(41);

              case 45:
                return _context.finish(38);

              case 46:
                _context.next = 50;
                break;

              case 48:
                _context.next = 50;
                return toCoreInterface(toCamelWithMetadata(result));

              case 50:
                _iteratorNormalCompletion = true;
                _context.next = 10;
                break;

              case 53:
                _context.next = 59;
                break;

              case 55:
                _context.prev = 55;
                _context.t1 = _context["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 59:
                _context.prev = 59;
                _context.prev = 60;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 64;
                  break;
                }

                _context.next = 64;
                return _awaitAsyncGenerator(_iterator.return());

              case 64:
                _context.prev = 64;

                if (!_didIteratorError) {
                  _context.next = 67;
                  break;
                }

                throw _iteratorError;

              case 67:
                return _context.finish(64);

              case 68:
                return _context.finish(59);

              case 69:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 55, 59, 69], [23, 34, 38, 46], [39,, 41, 45], [60,, 64, 68]]);
      }));

      function ls(_x) {
        return _ls.apply(this, arguments);
      }

      return ls;
    }()
  );
});

function toCoreInterface(entry) {
  if (entry.hash) entry.cid = new CID(entry.hash);
  delete entry.hash;
  return entry;
}